const Array_Sort_Numbers = (inputarray) => {
  return inputarray.sort(function(a, b) {
    return a - b;
  });
}
export default Array_Sort_Numbers;
